import React from 'react';
import approve from '../assets/images/status_icons/approve.png';
import denied from '../assets/images/status_icons/denied.png';
import close from '../assets/images/status_icons/close.png';

const StatusTag = ({ status }) => {
  return (
    <span
      className={
        'status ' +
        (status === 'Approved'
          ? 'approved'
          : status === 'Declined'
          ? 'cancel'
          : status === 'Removed'
          ? 'pending'
          : '')
      }
    >
      <img
        alt="status-icon"
        src={
          status === 'Approved'
            ? approve
            : status === 'Declined'
            ? denied
            : status === 'Removed'
            ? close
            : ''
        }
        height={20}
        width={20}
        className="status-tag-icon"
      />

      {status}
    </span>
  );
};

export default StatusTag;
